export default "__VITE_ASSET__5a340833__"